import React, { PureComponent } from 'react'
import ReactCardFlip from 'react-card-flip'
import { KTColors } from '../../Constants/KTColors'
import {
  heightPercentageToDP as heightPercentage,
  widthPercentageToDP as widthPercentage,
} from '../../../Utils/ResponsiveScreen'
import { fonts } from '../../Constants/theme'
import _ from 'lodash'
import StoryContentView from './StoryContentView'
import AwsConfig from '../../../Config/AwsConfig'

const styles = {
  container: {
    flex: 1,
    width: '100%',
  },
  cardContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  card: {
    width: widthPercentage('100%'),
    height: heightPercentage('100%'),
    justifyContent: 'center',
    alignItems: 'center',
    padding: widthPercentage('5%'),
  },

  questionText: {
    textAlign: 'center',
    fontFamily: fonts.fontFamilyPoppinsLight,
    fontSize: heightPercentage('2.8%'),
    fontWeight: 'bold',
    marginBottom: heightPercentage('1%'),
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonText: {
    fontSize: heightPercentage('2.4%'),
    lineHeight: heightPercentage('3%'),
    fontFamily: fonts.fontFamilyPoppinsLight,
  },
  button: {
    borderWidth: 0.8,
    opacity: 0.8,
    width: widthPercentage('90%'),
    marginTop: heightPercentage('1.5%'),
  },

  questionsContentPoster: {
    height: heightPercentage('100'),
    resizeMode: 'cover',
  },
}
class McqContentView extends PureComponent {
  correctAnswers = []
  selectedAnswers = []
  selectedCorrectAnswers = []
  constructor(props) {
    super(props)
    const answersInfo = props.content && props.content.contentMetaInfo.mcqDetails.answersInfo
    answersInfo &&
      answersInfo.map((answerInfo) => {
        if (answerInfo.correct == 'true') {
          this.correctAnswers.push(answerInfo[`answer_${props.contentVisibleLang}`])
        }
      })
    const answersData = answersInfo ? answersInfo : []

    this.state = {
      answers: answersData,
      validateAnswer: false,
      validationColorVisibility: false,
    }
  }

  resetOptionsValidations = (selectedAnswer) => {
    setTimeout(() => {
      this.selectedAnswers = _.without(this.selectedAnswers, selectedAnswer)
      this.setState({ validateAnswer: !this.state.validateAnswer })
    }, 1500)
  }

  flipCard = () => {
    if (this.selectedCorrectAnswers.length == this.correctAnswers.length) {
      // this.props.changeCardTextColor()
      // this.card.flip()
      this.setState({ isFlipped: true })
      setTimeout(() => {
        this.resetSelections()
      }, 1000)
    }
  }

  reverseFlipCard = () => {
    this.setState({ isFlipped: false })
  }

  validateAnswer = (selectedAnswer) => {
    const answerOption = selectedAnswer[`answer_${this.props.contentVisibleLang}`]

    this.selectedAnswers.push(answerOption)
    if (selectedAnswer.correct == 'true') {
      this.selectedCorrectAnswers.push(answerOption)
    } else {
      // this.card.jiggle()
      this.resetOptionsValidations(answerOption)
    }
    this.flipCard()
    this.setState({ validateAnswer: !this.state.validateAnswer })
  }

  resetSelections = () => {
    this.selectedAnswers = []
    this.selectedCorrectAnswers = []
    this.setState({ validateAnswer: !this.state.validateAnswer })
  }

  closeMenu = () => {
    this.selectedAnswers = []
    this.selectedCorrectAnswers = []
    this.setState({ validateAnswer: !this.state.validateAnswer })
  }

  render() {
    const {
      content,
      mcqTitle,
      explanationCardTitle,
      answerExplanation,
      contentVisibleLang,
    } = this.props

    const { mcqOriginalImages, mcqImages } = content.contentMetaInfo.mcqDetails
    const textColor =
      content && content.contentMetaInfo.mcqDetails.textColor
        ? content.contentMetaInfo.mcqDetails.textColor
        : KTColors.white
    const mcqImage = mcqOriginalImages
      ? mcqOriginalImages[0].imageValue
      : mcqImages
        ? mcqImages[0].image
        : ''
    let cdnurl = AwsConfig.cdn_url
    const imageWithcdn = mcqImage ? mcqImage.includes(cdnurl) ? mcqImage : cdnurl + mcqImage : ''

    const cardTitle = explanationCardTitle ? explanationCardTitle : mcqTitle
    return (
      <div
        style={{
          height: heightPercentage('100%'),
          backgroundImage: `url(${imageWithcdn})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div style={styles.container}>
          <ReactCardFlip isFlipped={this.state.isFlipped} flipDirection='horizontal'>
            <div style={styles.card}>
              <div
                style={{
                  padding: heightPercentage('3%'),
                  alignItems: 'center',
                  alignSelf: 'center',
                  justifyContent: 'center',
                  height: heightPercentage('100%'),
                  marginTop: heightPercentage('35%'),
                }}
              >
                <p style={{ ...styles.questionText, ...{ color: textColor } }}>{mcqTitle}</p>
                {this.state.answers.map((answerInfo, index) => {
                  const answerOption = answerInfo[`answer_${contentVisibleLang}`]
                  var selectedColor = this.selectedAnswers.includes(answerOption)
                    ? answerInfo.correct == 'true'
                      ? KTColors.green800
                      : KTColors.red800
                    : 'transparent'
                  return (
                    <div
                      style={{
                        justifyContent: 'center',
                        alignSelf: 'center',
                        alignItems: 'center',
                        marginBottom: heightPercentage('1%'),
                        textAlign: 'center',
                      }}
                    >
                      <button
                        style={{
                          textAlign: 'center',
                          backgroundColor: 'transparent',
                          color: textColor,
                          paddingLeft: widthPercentage('3%'),
                          paddingRight: widthPercentage('3%'),
                          opacity: 0.8,
                          borderStyle: 'solid',
                          borderColor: textColor,
                          borderRadius: 5,
                          textAlign: 'center',
                          backgroundColor: selectedColor,
                        }}
                        onClick={() => this.validateAnswer(answerInfo)}
                      >
                        {answerOption}
                      </button>
                    </div>
                  )
                })}
              </div>
            </div>
            <StoryContentView
              contentID={content.contentID}
              isPausedVideo={false}
              content={content}
              likeVideo={() => null}
              bigLikeHandle={() => null}
              title={cardTitle}
              cardDescription={answerExplanation}
              cardImages={
                content.contentMetaInfo.mcqDetails.mcqOriginalCardImages
                  ? content.contentMetaInfo.mcqDetails.mcqOriginalCardImages
                  : content.contentMetaInfo.mcqDetails.mcqCardImages
              }
              showBottomLogo={this.props.showBottomLogo}
              flipCard={this.reverseFlipCard}
              closeButton={true}
              changeCardTextColor={this.props.changeCardTextColor}
              preview={this.props.preview}
              contentLinkDetails={content.contentMetaInfo.mcqDetails.contentLinkDetails}
              editContent={this.props.editContent}
              shareToFeed={this.props.shareToFeed}
              contentNewLinkDetails={this.props.contentNewLinkDetails}
            />
          </ReactCardFlip>
        </div>
      </div>
    )
  }
}

export default McqContentView
